<template>
  <div class="reviews-page">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="container mx-auto px-4 py-4">
        <nav class="flex" aria-label="Breadcrumb">
          <ol class="inline-flex items-center space-x-1 md:space-x-3">
            <li class="inline-flex items-center">
              <router-link to="/" class="inline-flex items-center text-sm font-medium text-gray-400 hover:text-white">
                <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                </svg>
                Home
              </router-link>
            </li>
            <li>
              <div class="flex items-center">
                <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
                </svg>
                <span class="ml-1 text-sm font-medium text-white md:ml-2">Game Reviews</span>
              </div>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <!-- 英雄区域 -->
    <div class="hero-section">
      <div class="container mx-auto px-4 py-16">
        <div class="text-center">
          <h1 class="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Game <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">Reviews</span>
          </h1>
          <p class="text-xl lg:text-2xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed">
            Discover the best browser games through comprehensive reviews, community ratings, and expert analysis. Make informed decisions about your next gaming adventure with insights from our community of 2.5M+ players.
          </p>
        </div>
      </div>
    </div>

    <!-- 评分统计 -->
    <div class="stats-section">
      <div class="container mx-auto px-4 py-16">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          <div class="stat-card bg-gray-800 rounded-lg p-6">
            <div class="text-4xl font-bold text-blue-400 mb-2">500+</div>
            <div class="text-gray-300">Games Reviewed</div>
          </div>
          <div class="stat-card bg-gray-800 rounded-lg p-6">
            <div class="text-4xl font-bold text-green-400 mb-2">150K+</div>
            <div class="text-gray-300">Community Reviews</div>
          </div>
          <div class="stat-card bg-gray-800 rounded-lg p-6">
            <div class="text-4xl font-bold text-purple-400 mb-2">4.7/5</div>
            <div class="text-gray-300">Average Rating</div>
          </div>
          <div class="stat-card bg-gray-800 rounded-lg p-6">
            <div class="text-4xl font-bold text-yellow-400 mb-2">25+</div>
            <div class="text-gray-300">Expert Reviewers</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 最新评论 -->
    <div class="latest-reviews-section">
      <div class="container mx-auto px-4 py-16">
        <h2 class="text-3xl lg:text-4xl font-bold text-white text-center mb-12">Latest Expert Reviews</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <article class="review-card bg-gray-800 rounded-lg overflow-hidden shadow-lg">
            <div class="p-6">
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center">
                  <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiM0QjVCRDEiLz4KPHR4dCB4PSIyMCIgeT0iMjQiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSI+QUo8L3RleHQ+Cjwvc3ZnPgo=" alt="Reviewer" class="w-10 h-10 rounded-full mr-3" />
                  <div>
                    <div class="text-white font-semibold">Alex Johnson</div>
                    <div class="text-gray-400 text-sm">Expert Reviewer</div>
                  </div>
                </div>
                <div class="flex items-center">
                  <div class="flex text-yellow-400 mr-2">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </div>
                  <span class="text-white font-bold">5.0</span>
                </div>
              </div>
              <h3 class="text-2xl font-bold text-white mb-3">Street Hidden Objects - A Masterpiece in Detail</h3>
              <div class="flex items-center text-sm text-gray-400 mb-4">
                <span class="bg-blue-600 text-white px-2 py-1 rounded-full text-xs mr-3">Puzzle</span>
                <span>December 15, 2024</span>
              </div>
              <p class="text-gray-300 mb-4 leading-relaxed">
                Street Hidden Objects sets a new standard for browser-based puzzle games. With its meticulously crafted urban environments and challenging object placement, this game offers hours of engaging gameplay. The attention to detail in each scene is remarkable, making every discovery feel rewarding.
              </p>
              <div class="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <div class="text-gray-400 text-sm">Graphics</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-green-600 h-2 rounded-full" style="width: 95%"></div>
                    </div>
                    <span class="text-white text-sm">9.5</span>
                  </div>
                </div>
                <div>
                  <div class="text-gray-400 text-sm">Gameplay</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-green-600 h-2 rounded-full" style="width: 90%"></div>
                    </div>
                    <span class="text-white text-sm">9.0</span>
                  </div>
                </div>
                <div>
                  <div class="text-gray-400 text-sm">Difficulty</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-yellow-600 h-2 rounded-full" style="width: 85%"></div>
                    </div>
                    <span class="text-white text-sm">8.5</span>
                  </div>
                </div>
                <div>
                  <div class="text-gray-400 text-sm">Replayability</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-blue-600 h-2 rounded-full" style="width: 80%"></div>
                    </div>
                    <span class="text-white text-sm">8.0</span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <button class="text-blue-400 hover:text-blue-300 font-medium">Read Full Review</button>
                <div class="text-gray-400 text-sm">1,234 helpful votes</div>
              </div>
            </div>
          </article>

          <article class="review-card bg-gray-800 rounded-lg overflow-hidden shadow-lg">
            <div class="p-6">
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center">
                  <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNFRDU0OEMiLz4KPHR4dCB4PSIyMCIgeT0iMjQiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSI+U0M8L3RleHQ+Cjwvc3ZnPgo=" alt="Reviewer" class="w-10 h-10 rounded-full mr-3" />
                  <div>
                    <div class="text-white font-semibold">Sarah Chen</div>
                    <div class="text-gray-400 text-sm">Gaming Specialist</div>
                  </div>
                </div>
                <div class="flex items-center">
                  <div class="flex text-yellow-400 mr-2">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                    <svg class="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </div>
                  <span class="text-white font-bold">4.2</span>
                </div>
              </div>
              <h3 class="text-2xl font-bold text-white mb-3">Action Arena - Fast-Paced Browser Combat</h3>
              <div class="flex items-center text-sm text-gray-400 mb-4">
                <span class="bg-red-600 text-white px-2 py-1 rounded-full text-xs mr-3">Action</span>
                <span>December 12, 2024</span>
              </div>
              <p class="text-gray-300 mb-4 leading-relaxed">
                Action Arena delivers solid browser-based combat with responsive controls and smooth animations. While the graphics are impressive for a web game, the repetitive gameplay and limited variety hold it back from greatness. Perfect for quick gaming sessions but lacks long-term engagement.
              </p>
              <div class="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <div class="text-gray-400 text-sm">Graphics</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-blue-600 h-2 rounded-full" style="width: 80%"></div>
                    </div>
                    <span class="text-white text-sm">8.0</span>
                  </div>
                </div>
                <div>
                  <div class="text-gray-400 text-sm">Gameplay</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-yellow-600 h-2 rounded-full" style="width: 70%"></div>
                    </div>
                    <span class="text-white text-sm">7.0</span>
                  </div>
                </div>
                <div>
                  <div class="text-gray-400 text-sm">Controls</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-green-600 h-2 rounded-full" style="width: 85%"></div>
                    </div>
                    <span class="text-white text-sm">8.5</span>
                  </div>
                </div>
                <div>
                  <div class="text-gray-400 text-sm">Variety</div>
                  <div class="flex items-center">
                    <div class="w-full bg-gray-700 rounded-full h-2 mr-2">
                      <div class="bg-red-600 h-2 rounded-full" style="width: 60%"></div>
                    </div>
                    <span class="text-white text-sm">6.0</span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <button class="text-blue-400 hover:text-blue-300 font-medium">Read Full Review</button>
                <div class="text-gray-400 text-sm">892 helpful votes</div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>

    <!-- 社区评论亮点 -->
    <div class="community-highlights-section">
      <div class="container mx-auto px-4 py-16">
        <h2 class="text-3xl lg:text-4xl font-bold text-white text-center mb-12">Community Highlights</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div class="highlight-card bg-gray-800 rounded-lg p-6">
            <div class="flex items-center mb-4">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiMxMEI5ODEiLz4KPHR4dCB4PSIyMCIgeT0iMjQiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSI+TUc8L3RleHQ+Cjwvc3ZnPgo=" alt="User" class="w-10 h-10 rounded-full mr-3" />
              <div>
                <div class="text-white font-semibold">MikeGamer2024</div>
                <div class="text-gray-400 text-sm">Community Member</div>
              </div>
            </div>
            <p class="text-gray-300 mb-3">
              "The puzzle games on this platform are absolutely fantastic! The variety and quality are unmatched. I've been playing for 6 months and still discovering new favorites."
            </p>
            <div class="flex items-center text-sm text-gray-400">
              <span class="mr-4">👍 156 likes</span>
              <span>2 days ago</span>
            </div>
          </div>

          <div class="highlight-card bg-gray-800 rounded-lg p-6">
            <div class="flex items-center mb-4">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNGNTk5MjgiLz4KPHR4dCB4PSIyMCIgeT0iMjQiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSI+TFA8L3RleHQ+Cjwvc3ZnPgo=" alt="User" class="w-10 h-10 rounded-full mr-3" />
              <div>
                <div class="text-white font-semibold">LunaPlayer</div>
                <div class="text-gray-400 text-sm">Pro Gamer</div>
              </div>
            </div>
            <p class="text-gray-300 mb-3">
              "As someone who reviews games professionally, I'm impressed by the curation quality here. Each game is tested and optimized. The performance is consistently excellent across all browsers."
            </p>
            <div class="flex items-center text-sm text-gray-400">
              <span class="mr-4">👍 203 likes</span>
              <span>1 week ago</span>
            </div>
          </div>

          <div class="highlight-card bg-gray-800 rounded-lg p-6">
            <div class="flex items-center mb-4">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiM4QjVDRjYiLz4KPHR4dCB4PSIyMCIgeT0iMjQiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSI+QUg8L3RleHQ+Cjwvc3ZnPgo=" alt="User" class="w-10 h-10 rounded-full mr-3" />
              <div>
                <div class="text-white font-semibold">ArcadeHero</div>
                <div class="text-gray-400 text-sm">Gaming Enthusiast</div>
              </div>
            </div>
            <p class="text-gray-300 mb-3">
              "The community here is amazing! Great discussions, helpful tips, and friendly competition. The weekly tournaments add an extra layer of excitement to casual gaming."
            </p>
            <div class="flex items-center text-sm text-gray-400">
              <span class="mr-4">👍 127 likes</span>
              <span>3 days ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 评分系统说明 -->
    <div class="rating-system-section">
      <div class="container mx-auto px-4 py-16">
        <div class="bg-gray-800 rounded-lg p-8">
          <h2 class="text-3xl font-bold text-white text-center mb-8">Our Review System</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 class="text-xl font-semibold text-white mb-4">Expert Reviews</h3>
              <p class="text-gray-300 mb-4">
                Our team of gaming experts thoroughly tests each game across multiple criteria including graphics, gameplay, controls, difficulty balance, and replay value. Each review includes detailed analysis and scoring.
              </p>
              <ul class="text-gray-300 space-y-2">
                <li class="flex items-center">
                  <svg class="w-4 h-4 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  Comprehensive testing across all major browsers
                </li>
                <li class="flex items-center">
                  <svg class="w-4 h-4 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  Performance analysis on different devices
                </li>
                <li class="flex items-center">
                  <svg class="w-4 h-4 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  Detailed scoring breakdown
                </li>
              </ul>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-white mb-4">Community Reviews</h3>
              <p class="text-gray-300 mb-4">
                Our community of 2.5M+ players contributes valuable insights through ratings and reviews. Community feedback helps other players discover games that match their preferences and play style.
              </p>
              <ul class="text-gray-300 space-y-2">
                <li class="flex items-center">
                  <svg class="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  Real player experiences and opinions
                </li>
                <li class="flex items-center">
                  <svg class="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  Helpful voting system for quality control
                </li>
                <li class="flex items-center">
                  <svg class="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  Moderated for quality and relevance
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'Reviews',
  setup() {
    // 这里可以添加评论相关的逻辑
    return {
      // 返回响应式数据
    }
  }
}
</script>

<style scoped>
.reviews-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.hero-section {
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.9) 0%, rgba(22, 33, 62, 0.9) 100%);
  backdrop-filter: blur(10px);
}

.stat-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.stat-card:hover {
  border-color: rgba(59, 130, 246, 0.5);
  transform: translateY(-2px);
}

.review-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.review-card:hover {
  border-color: rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
}

.highlight-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.highlight-card:hover {
  border-color: rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 640px) {
  .hero-section h1 {
    font-size: 3rem;
  }
}
</style>
